import { LoanChargesTable } from './LoanChargesTable'
import { LoanChargeOwedBy, LoanChargeType } from './types'

export default function LoanCharges({ isLoan = true }: { isLoan?: any }) {
  return (
    <div className={`invoices-container`}>
      <div className="max-w-screen-2xl m-auto">
        <div className={`relative bg-white`}>
          {/* Each LoanChargesTable renders its own section header (Loan Charges / Unpaid Interest /
              Unpaid Default Interest / Unpaid Late Charges / Lender Charges), so no page-level
              title is needed here. */}
          <LoanChargesTable isLoan={isLoan} loanChargeType={LoanChargeType.LoanCharges} />
          <LoanChargesTable isLoan={isLoan} loanChargeType={LoanChargeType.UnpaidInterest} />
          <LoanChargesTable isLoan={isLoan} loanChargeType={LoanChargeType.UnpaidDefaultInterest} />
          <LoanChargesTable isLoan={isLoan} loanChargeType={LoanChargeType.UnpaidLateCharges} />
          {/* Charges owed by the lender rather than the borrower: never billed, and recovered out
              of what that lender is next distributed. Its own section because it is the other side
              of the book - the totals above are money the borrower owes. */}
          <LoanChargesTable isLoan={isLoan} loanChargeType={LoanChargeType.LoanCharges} owedBy={LoanChargeOwedBy.Lender} />
        </div>
      </div>
    </div>
  )
}
